import { crudMdActions } from "@/services/crud-md-actions";

const name = "assets";

export default {
  name,
  ...crudMdActions(name),
};
